/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */


// suggest improvements for this component
// give me the entire code to copy
// ran this thru claudes code refactoring tool



// redesign this component to look more elegant and polished and accents
// and add a little more pizzaz to the menu items and add hover effects 
// use tailwind css in the className directive 
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task
// "Colors come from dynamic seller props — use hex + opacity string concatenation
//  (e.g. sellerPrimaryColor1 + sellerColorSuffixDark) for tints, never hardcode colors."
// sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
// give me the entire code to copy


// when i click Add All To My Menu i get double the toast messages
// give me the entire code to copy

import React, { useEffect, useState, lazy, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { sampleMenu_webSiteOrigin_get } from '../../store/reducers/sampleMenuReducer';
import { products_get_by_productIds } from '../../store/reducers/homeReducer';
import {
  add_to_cart, get_cart_products, move_from_cart_to_wishlist,
  messageClear, successMessage, errorMessage
} from '../../store/reducers/cartReducer';

import { HiOutlineMagnifyingGlassPlus, HiOutlineMagnifyingGlassMinus } from "react-icons/hi2";
import { MdOutlineRestaurantMenu, MdOutlineOpenInBrowser } from "react-icons/md";
import { FaEye } from "react-icons/fa";
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";

import ShopProductGridListView from '../../components/products/ShopProductGridListView';
import OrnamentalDivider from '../../components/customerDashboard/CustomerDashboardComponents/OrnamentalDivider';
import Modal2 from '../Modal2';
import useWindowSize from '../../utils/useWindowSize';
import GetSellerConfig from '../GetSellerConfig';

import toast from 'react-hot-toast';
import { currencyFormat } from '../CurrencyFormat';
import ImageModal from './ImageModal';

import config from '../../config';

const Rating = lazy(() => import('../Rating'));

const SampleMenusImages = () => {
    const sellerFrontendURL = config.STR_FRONTEND_URL;
    const { userInfo } = useSelector(state => state.auth);

    let { products } = useSelector(state => state.home);
    const { sampleMenus } = useSelector(state => state.sampleMenu);
    const { cart_products, errorMessage: cartError, successMessage: cartSuccess } =
        useSelector(state => state.cart);

    const {
        sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerProductTerm, sellerProductPluralTerm,
        sellerBoolShowSiteChat, sellerBoolShowSitePayments, sellerBoolShowSiteRating
    } = GetSellerConfig();

    const [selectedImg, setSelectedImg] = useState(null);
    const [modalProduct, setModalProduct] = useState(null);
    const { screenWidth } = useWindowSize();
    const tooltipHoverStyle = {
        color: 'white',
        backgroundColor: sellerPrimaryColor1
    };
    const openModal = (product) => setModalProduct(product);
    const closeModal = () => setModalProduct(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Track how many add_to_cart dispatches are in flight
    const pendingCartAdds = useRef(0);

    const redirect_chat_page = (chatTopic) => {
        if (userInfo) {
            navigate(`/customerDashboard/chat/${chatTopic}`);
        } else {
            navigate('/login');
        }
    };

    useEffect(() => {
        dispatch(sampleMenu_webSiteOrigin_get(sellerFrontendURL));
    }, [sellerFrontendURL, dispatch]);

    useEffect(() => {
        dispatch(get_cart_products(userInfo.id));
    }, []);

    const add_sample_menu_to_cart_local = () => {
        if (userInfo) {
            if (cart_products.length > 0) {
                cart_products[0].products.map((p) => dispatch(move_from_cart_to_wishlist(p._id)));
            }
            pendingCartAdds.current = products.length;
            products.map((p) =>
                dispatch(add_to_cart({ userId: userInfo.id, quantity: 1, productId: p._id, portionSize: '' }))
            );
        } else {
            navigate('/login');
        }
    };

    const myScreenWidth = 270;
    const [imageSize, setImageSize] = useState(myScreenWidth);
    const minImageSize = 50;
    const imageSizeStep = 30;

    const handleImageSizeChangeIncrease = () => setImageSize(prev => prev + imageSizeStep);
    const handleImageSizeChangeDecrease = () => {
        if (imageSize > minImageSize) setImageSize(prev => prev - imageSizeStep);
    };

    const [sampleMenuFileName, setSampleMenuFileName] = useState('');
    const [sampleMenuTitle, setSampleMenuTitle] = useState('');
    const [productsDisplay, setProductsDisplay] = useState('[]');
    const [sellerPackageTitle, setSellerPackageTitle] = useState('');

    useEffect(() => {
        if (sampleMenus[0]?.sampleMenuFile) {
            setSampleMenuFileName(sampleMenus[0]?.sampleMenuFile);
            setSampleMenuTitle(sampleMenus[0]?.title);
        }
    }, [sampleMenus]);

    const handleSampleMenuNameChange = (event) => {
        const sampleMenuId = event.target.value;
        try {
        sampleMenus.forEach((sampleMenu) => {
            if (sampleMenu._id === sampleMenuId) {
            setSampleMenuFileName(sampleMenu.sampleMenuFile);
            setSampleMenuTitle(sampleMenu.title);
            setProductsDisplay(sampleMenu.selectedProducts);
            setSellerPackageTitle(
                sampleMenu?.packageDetails?.length > 0
                ? ' Associated Package: ' + sampleMenu.packageDetails[0]?.title
                : ''
            );
            let productIds = '';
            if (JSON.parse(sampleMenu.selectedProducts).length > 0) {
                JSON.parse(sampleMenu.selectedProducts).map((p) => (productIds += `${p._id},`));
                productIds = productIds.slice(0, -1);
                dispatch(products_get_by_productIds(productIds));
            }
            }
        });
        } catch (error) {}
    };

    useEffect(() => {
        if (cartSuccess) {
            dispatch(messageClear());
            if (pendingCartAdds.current > 0) {
                pendingCartAdds.current -= 1;
                if (pendingCartAdds.current === 0) {
                    // All batch adds are done — show one toast and refresh cart
                    toast.success(cartSuccess);
                    dispatch(get_cart_products(userInfo.id));
                }
                // else: still waiting for remaining dispatches, stay silent
            } else {
                // Normal single-item add (not from batch)
                toast.success(cartSuccess);
                dispatch(get_cart_products(userInfo.id));
            }
        }
        if (cartError) {
            toast.error(cartError);
            dispatch(messageClear());
        }
    }, [cartSuccess, cartError]);

    // ─── Derived dynamic color tokens ────────────────────────────────────────────
    const colorDark   = sellerPrimaryColor1 + sellerColorSuffixDark;
    const colorMedium = sellerPrimaryColor1 + sellerColorSuffixMedium;
    const colorLight  = sellerPrimaryColor1 + sellerColorSuffixLight;
    const bgComponent = sellerComponentBackgroundColor;

    const hasProducts = productsDisplay !== '[]';

return (
    <div className="bg-white rounded-2xl">
        <div
            className="relative rounded-2xl p-4 overflow-hidden border"
            style={{ 
                borderColor: colorDark, 
                backgroundColor: colorLight, 
                color: colorDark
            }}>
            {/* ── Subtle top accent stripe ─────────────────────────────────────────── */}
            <div
                className="hidden absolute top-0 left-0 right-0 h-[3px]"
                style={{ background: `linear-gradient(90deg, ${sellerPrimaryColor1}, ${colorMedium}, ${sellerPrimaryColor1})` }}
            />

            <div className="p-0 pt-0">
                {/* ── Header ────────────────────────────────────────────────────────── */}
                <div className="flex items-center gap-2 mb-1 pb-0">
                    <div>
                        <MdOutlineRestaurantMenu size={52} style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />
                    </div>
                    <div>
                        <h2
                            className="text-2xl font-bold tracking-tight leading-none"
                            style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                            Sample Menus
                        </h2>
                        <p className="text-md sm:text-xs xs:text-xs mt-0.5" style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                            Browse our curated selections and add an entire sample menu to My Menu in one click
                        </p>
                    </div>
                </div>

                {/* ── Menu Selector ─────────────────────────────────────────────────── */}
                <div className="mb-5">
                    <label
                        className="block text-[11px] font-semibold uppercase tracking-widest mt-1.5 mb-1.5"
                        style={{ color: sellerPrimaryColor1+ sellerColorSuffixMedium }}>
                        Select a Menu
                    </label>
                    <div className="relative">
                        <select
                            onChange={handleSampleMenuNameChange}
                            className="w-full appearance-none rounded-xl border px-4 py-2.5 pr-10 text-sm font-medium
                                cursor-pointer outline-none transition-all duration-200
                                focus:ring-2 focus:ring-offset-1"
                            style={{
                                color: colorDark,
                                backgroundColor: colorLight,
                                borderColor: colorDark,
                            }}>
                            {sampleMenus.map((c, i) => (
                                <option key={i} value={c._id}>{c.title}</option>
                            ))}
                        </select>
                        {/* Custom chevron */}
                        <div
                            className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2"
                            style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <OrnamentalDivider />   
                {/* ── Two-column layout: side by side on md+, stacked on mobile
                    flex flex-col md:flex-row gap-4
                ─────── */}
                <div className="grid grid-cols-2 sm:grid-cols-1 xs:grid-cols-1 gap-4">

                    {/* ── Image Viewer Panel ──────────────────────────────────────────── */}
                    <div
                        className="rounded-xl border overflow-hidden relative flex-1"
                        style={{ 
                            borderColor: colorDark, 
                            borderTop: `6px solid ${colorDark}`,
                        }}>
                        {/* Control bar */}
                        <div
                            className="flex items-center justify-between px-3 py-1.5 border-b"
                            style={{ borderColor: colorLight, backgroundColor: colorLight }}>
                            <span
                                className="text-[11px] font-semibold uppercase tracking-wider"
                                style={{ color: sellerPrimaryColor1 }}>
                                Preview
                            </span>
                            <div className="flex items-center gap-1">
                                <button
                                    onClick={() => setSelectedImg(sampleMenuFileName)}
                                    className="p-1.5 border-none rounded-lg transition-all duration-200 hover:scale-110"
                                    style={{ 
                                        color: sellerPrimaryColor1 + sellerColorSuffixDark, 
                                        backgroundColor: colorLight, 
                                        borderColor: sellerPrimaryColor1 + sellerColorSuffixDark
                                    }}
                                    title="Open full size in popup">
                                    <MdOutlineOpenInBrowser size={18} />
                                </button>
                                <button
                                    onClick={handleImageSizeChangeIncrease}
                                    className="p-1.5 rounded-lg transition-all duration-200 hover:scale-110"
                                    style={{ color: sellerPrimaryColor1, backgroundColor: colorLight }}
                                    title="Zoom in">
                                    <HiOutlineMagnifyingGlassPlus size={18} />
                                </button>
                                <button
                                    onClick={handleImageSizeChangeDecrease}
                                    className="p-1.5 rounded-lg transition-all duration-200 hover:scale-110"
                                    style={{ color: sellerPrimaryColor1, backgroundColor: colorLight }}
                                    title="Zoom out">
                                    <HiOutlineMagnifyingGlassMinus size={18} />
                                </button>
                            </div>
                        </div>

                        {/* Image area  */}
                        <div
                            className="overflow-auto items-center justify-center flex"
                            style={{ height: '356px', padding: '8px', backgroundColor: colorLight }}>
                            <div className="relative p-2 inline-block" style={{ width: `${imageSize + 4}px` }}>
                                <img
                                    className="cursor-pointer transition-transform duration-200 hover:scale-[1.01]"
                                    src={sampleMenuFileName}
                                    onClick={() => setSelectedImg(sampleMenuFileName)}
                                    style={{ width: `${imageSize}px`, height: 'auto' }}
                                    alt="Sample menu preview"
                                />
                                <ImageModal
                                    src={selectedImg}
                                    onClose={() => setSelectedImg(null)}
                                    title={sampleMenuTitle}
                                />
                            </div>
                        </div>
                    </div>

                    {/* ── Product List Panel ──────────────────────────────────────────── */}
                    <div
                        className="rounded-xl border overflow-hidden flex-1"
                        style={{ 
                            borderColor: colorDark, 
                            backgroundColor: colorLight,
                            borderTop: `6px solid ${colorDark}`, 
                        }}>
                        {/* Add-to-cart CTA */}
                        {hasProducts && (
                            <div
                                className="px-3 pt-3 pb-2 mb-1 border-b"
                                style={{ 
                                    borderColor: colorDark, 
                                    backgroundColor: colorLight 
                                }}> 
                                <button
                                    onClick={add_sample_menu_to_cart_local}
                                    className="w-full flex items-center justify-center gap-1 py-2.5 px-4
                                        rounded-xl text-sm font-semibold tracking-wide text-white
                                        transition-all duration-200 hover:opacity-90 hover:shadow-md active:scale-[0.98]"
                                    style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                    <MdOutlineRestaurantMenu size={20} />
                                    {`Add All To My Menu (${products?.length})`}
                                </button>
                                <p
                                    className="text-center text-[11px] mt-1.5 leading-tight"
                                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                    Existing {sellerProductPluralTerm} will move to your Wishlist
                                </p>
                                {sellerPackageTitle && (
                                    <p
                                        className="text-center text-[12px] font-semibold mt-1"
                                        style={{ color: sellerPrimaryColor1 }}>
                                        {sellerPackageTitle}
                                    </p>
                                )}
                            </div>
                        )}

                    {/* Scrollable content */}
                    <div
                        className="overflow-auto"
                        style={{ height: hasProducts ? '280px' : '320px', padding: '10px' }}>
                        {/* Intro state */}
                        {!hasProducts && (
                            <div className="flex flex-col gap-4 py-4 px-1">
                                {[
                                    { icon: '①', text: "Choose a sample menu from the selector above." },
                                    { icon: '②', text: "You'll see both a Classic and Modern view side by side." },
                                    { icon: '③', text: "Add the entire menu to your cart in one click." },
                                ].map(({ icon, text }, i) => (
                                    <div key={i} className="flex items-start gap-3">
                                        <span
                                            className="text-lg font-bold shrink-0 leading-tight"
                                            style={{ color: sellerPrimaryColor1 }}>
                                            {icon}
                                        </span>
                                        <p className="text-sm leading-snug opacity-70" style={{ color: sellerPrimaryColor1 }}>
                                            {text}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        )}
                        <div>
                            {hasProducts && (
                                <ShopProductGridListView products={products}
                                    styles="grid" showAllProductsButton={false} columnCount={1} />
                            )}
                        </div>
                        {/* Product cards flex flex-col */}
                        {hasProducts && (
                            <div className="hidden  gap-3">
                                {products
                                    .slice()
                                    .sort((a, b) => a.name.localeCompare(b.name))
                                    .map((p, i) => (
                                        <div
                                            key={i}
                                            className="group relative rounded-xl border overflow-hidden
                                                transition-all duration-300
                                                hover:-translate-y-1 hover:shadow-xl"
                                            style={{
                                                backgroundColor: colorLight,
                                                borderColor: colorDark,
                                            }}>
                                            {/* ── Image with zoom + overlay ─────────────────── */}
                                            <div className="relative overflow-hidden">
                                                <img
                                                    className="w-full object-cover transition-transform duration-500 
                                                    group-hover:scale-105"
                                                    src={p.images[0]}
                                                    alt={p.name}
                                                    style={{ maxHeight: '140px' }}
                                                />

                                                {/* Color sweep overlay on hover */}
                                                <div
                                                    className="absolute inset-0 opacity-0 group-hover:opacity-30 
                                                    transition-opacity duration-300"
                                                    style={{ backgroundColor: sellerPrimaryColor1 }}
                                                />

                                                {/* byThePan badge */}
                                                {p.byThePan !== 'NoPan' && (
                                                    <div
                                                        className="absolute top-2 left-2 text-[10px] text-white 
                                                        font-semibold px-2 py-0.5 rounded-full"
                                                        style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                                        {p.byThePan}
                                                    </div>
                                                )}

                                                {/* Action buttons — slide up on hover */}
                                                <div
                                                    className="absolute inset-x-0 bottom-0 flex justify-center items-center gap-2 pb-2
                                                    translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                                                    <button
                                                        onClick={() => openModal(p)}
                                                        className="w-9 h-9 flex items-center justify-center rounded-full
                                                        backdrop-blur-sm border text-sm
                                                        transition-all duration-200 hover:scale-110 hover:shadow-lg"
                                                        style={{ 
                                                            backgroundColor: 'rgba(255,255,255,0.92)', 
                                                            color: sellerPrimaryColor1, 
                                                            borderColor: sellerPrimaryColor1
                                                        }}
                                                        title="Quick View">
                                                        
                                                        <div className="icon-container">
                                                            <span className='icon flex justify-center items-center'>
                                                                &nbsp;<FaEye size={18} />&nbsp;
                                                            </span>
                                                            <div className="tooltip" style={tooltipHoverStyle}>Quick<br />View</div>
                                                        </div>
                                                    </button>

                                                    {sellerBoolShowSiteChat && (
                                                        <button
                                                            onClick={() => redirect_chat_page(p.name)}
                                                            className="w-9 h-9 flex items-center justify-center rounded-full
                                                            backdrop-blur-sm border text-sm
                                                            transition-all duration-200 hover:scale-110 hover:shadow-lg"
                                                            style={{ 
                                                                backgroundColor: 'rgba(255,255,255,0.92)', 
                                                                color: sellerPrimaryColor1, 
                                                                borderColor: sellerPrimaryColor1 
                                                            }}
                                                            title="Chat With Us">
                                                            <div className="icon-container">
                                                                <span className='icon flex justify-center items-center'>
                                                                    &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
                                                                </span>
                                                                <div className="tooltip" style={tooltipHoverStyle}>Chat<br />With Us</div>
                                                            </div>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>

                                            {/* ── Card body ─────────────────────────────────── */}
                                            <div className="px-3 pt-2 pb-1">
                                                {/* Animated left-border accent on hover */}
                                                <div
                                                    className="absolute left-0 top-0 bottom-0 w-[3px] rounded-l-xl
                                                    scale-y-0 group-hover:scale-y-100 transition-transform 
                                                    duration-300 origin-top"
                                                    style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}
                                                />
                                                <div
                                                    className="font-semibold text-sm leading-snug tracking-tight truncate"
                                                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                                    {p.name}
                                                </div>

                                                <div className="flex items-center gap-2 mt-0.5 mb-1">
                                                    {sellerBoolShowSitePayments && (
                                                        <span
                                                            className="text-sm font-bold"
                                                            style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                                            {currencyFormat.format(p.price)}
                                                        </span>
                                                    )}
                                                    {sellerBoolShowSiteRating && (
                                                        <React.Suspense fallback={null}>
                                                            <Rating ratings={p.rating} />
                                                        </React.Suspense>
                                                    )}
                                                </div>
                                            </div>

                                            {/* ── Description strip ─────────────────────────── */}
                                            <div
                                                className="px-3 py-1.5 text-[11px] leading-snug border-t opacity-70 truncate"
                                                style={{
                                                    borderColor: colorLight,
                                                    color: sellerPrimaryColor1,
                                                    backgroundColor: colorLight,
                                                }}>
                                                {p.description?.substring(0, parseInt(screenWidth / 28))}…
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                </div>{/* end two-column */}
            </div>

            <Modal2 isOpen={!!modalProduct} onClose={closeModal} product={modalProduct} />
        </div>
    </div>
  );
};

export default SampleMenusImages;








//double the toast messages
// import React, { useEffect, useState, lazy } from 'react';
// import { useNavigate, Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { sampleMenu_webSiteOrigin_get } from '../../store/reducers/sampleMenuReducer';
// import { products_get_by_productIds } from '../../store/reducers/homeReducer';
// import {
//   add_to_cart, get_cart_products, move_from_cart_to_wishlist,
//   messageClear, successMessage, errorMessage
// } from '../../store/reducers/cartReducer';

// import { HiOutlineMagnifyingGlassPlus, HiOutlineMagnifyingGlassMinus } from "react-icons/hi2";
// import { MdOutlineRestaurantMenu, MdOutlineOpenInBrowser } from "react-icons/md";
// import { FaEye } from "react-icons/fa";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";

// import ShopProductGridListView from '../../components/products/ShopProductGridListView';
// import Modal2 from '../Modal2';
// import useWindowSize from '../../utils/useWindowSize';
// import GetSellerConfig from '../GetSellerConfig';

// import toast from 'react-hot-toast';
// import { currencyFormat } from '../CurrencyFormat';
// import ImageModal from './ImageModal';

// import config from '../../config';

// const Rating = lazy(() => import('../Rating'));

// const SampleMenusImages = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL;
//     const { userInfo } = useSelector(state => state.auth);

//     let { products } = useSelector(state => state.home);
//     const { sampleMenus } = useSelector(state => state.sampleMenu);
//     const { cart_products, errorMessage: cartError, successMessage: cartSuccess } =
//         useSelector(state => state.cart);

//     const {
//         sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//         sellerProductTerm, sellerProductPluralTerm,
//         sellerBoolShowSiteChat, sellerBoolShowSitePayments, sellerBoolShowSiteRating
//     } = GetSellerConfig();

//     const [selectedImg, setSelectedImg] = useState(null);
//     const [modalProduct, setModalProduct] = useState(null);
//     const { screenWidth } = useWindowSize();
//     const tooltipHoverStyle = {
//         color: 'white',
//         backgroundColor: sellerPrimaryColor1
//     };
//     const openModal = (product) => setModalProduct(product);
//     const closeModal = () => setModalProduct(null);

//     const dispatch = useDispatch();
//     const navigate = useNavigate();

//     const redirect_chat_page = (chatTopic) => {
//         if (userInfo) {
//             navigate(`/customerDashboard/chat/${chatTopic}`);
//         } else {
//             navigate('/login');
//         }
//     };

//     useEffect(() => {
//         dispatch(sampleMenu_webSiteOrigin_get(sellerFrontendURL));
//     }, [sellerFrontendURL, dispatch]);

//     useEffect(() => {
//         dispatch(get_cart_products(userInfo.id));
//     }, []);

//     const add_sample_menu_to_cart_local = () => {
//         if (userInfo) {
//             if (cart_products.length > 0) {
//                 cart_products[0].products.map((p) => dispatch(move_from_cart_to_wishlist(p._id)));
//             }
//             products.map((p) =>
//                 dispatch(add_to_cart({ userId: userInfo.id, quantity: 1, productId: p._id, portionSize: '' }))
//             );
//         } else {
//             navigate('/login');
//         }
//     };

//     const myScreenWidth = 270;
//     const [imageSize, setImageSize] = useState(myScreenWidth);
//     const minImageSize = 50;
//     const imageSizeStep = 30;

//     const handleImageSizeChangeIncrease = () => setImageSize(prev => prev + imageSizeStep);
//     const handleImageSizeChangeDecrease = () => {
//         if (imageSize > minImageSize) setImageSize(prev => prev - imageSizeStep);
//     };

//     const [sampleMenuFileName, setSampleMenuFileName] = useState('');
//     const [sampleMenuTitle, setSampleMenuTitle] = useState('');
//     const [productsDisplay, setProductsDisplay] = useState('[]');
//     const [sellerPackageTitle, setSellerPackageTitle] = useState('');

//     useEffect(() => {
//         if (sampleMenus[0]?.sampleMenuFile) {
//             setSampleMenuFileName(sampleMenus[0]?.sampleMenuFile);
//             setSampleMenuTitle(sampleMenus[0]?.title);
//         }
//     }, [sampleMenus]);

//     const handleSampleMenuNameChange = (event) => {
//         const sampleMenuId = event.target.value;
//         try {
//         sampleMenus.forEach((sampleMenu) => {
//             if (sampleMenu._id === sampleMenuId) {
//             setSampleMenuFileName(sampleMenu.sampleMenuFile);
//             setSampleMenuTitle(sampleMenu.title);
//             setProductsDisplay(sampleMenu.selectedProducts);
//             setSellerPackageTitle(
//                 sampleMenu?.packageDetails?.length > 0
//                 ? ' Associated Package: ' + sampleMenu.packageDetails[0]?.title
//                 : ''
//             );
//             let productIds = '';
//             if (JSON.parse(sampleMenu.selectedProducts).length > 0) {
//                 JSON.parse(sampleMenu.selectedProducts).map((p) => (productIds += `${p._id},`));
//                 productIds = productIds.slice(0, -1);
//                 dispatch(products_get_by_productIds(productIds));
//             }
//             }
//         });
//         } catch (error) {}
//     };

//     useEffect(() => {
//         if (cartSuccess) {
//             toast.success(cartSuccess);
//             dispatch(messageClear());
//             dispatch(get_cart_products(userInfo.id));
//         }
//         if (cartError) {
//             toast.error(cartError);
//             dispatch(messageClear());
//         }
//     }, [cartSuccess, cartError]);

//     // ─── Derived dynamic color tokens ────────────────────────────────────────────
//     const colorDark   = sellerPrimaryColor1 + sellerColorSuffixDark;
//     const colorMedium = sellerPrimaryColor1 + sellerColorSuffixMedium;
//     const colorLight  = sellerPrimaryColor1 + sellerColorSuffixLight;
//     const bgComponent = sellerComponentBackgroundColor;

//     const hasProducts = productsDisplay !== '[]';

// return (
//     <div className="bg-white rounded-2xl">
//         <div
//             className="relative rounded-2xl p-4 overflow-hidden shadow-lg border"
//             style={{ 
//                 borderColor: colorDark, 
//                 backgroundColor: colorLight, 
//                 color: colorDark
//             }}>
//             {/* ── Subtle top accent stripe ─────────────────────────────────────────── */}
//             <div
//                 className="hidden absolute top-0 left-0 right-0 h-[3px]"
//                 style={{ background: `linear-gradient(90deg, ${sellerPrimaryColor1}, ${colorMedium}, ${sellerPrimaryColor1})` }}
//             />

//             <div className="p-0 pt-0">
//                 {/* ── Header ────────────────────────────────────────────────────────── */}
//                 <div className="flex items-center gap-1.5">
//                     <div>
//                         <MdOutlineRestaurantMenu size={42} style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />
//                     </div>
//                     <div>
//                         <h2
//                             className="text-2xl font-bold tracking-tight leading-none"
//                             style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                             Sample Menus
//                         </h2>
//                         <p className="text-xs mt-0.5" style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
//                             Browse our curated selections and add an entire sample menu to My Menu in one click
//                         </p>
//                     </div>
//                 </div>

//                 {/* ── Menu Selector ─────────────────────────────────────────────────── */}
//                 <div className="mb-5">
//                     <label
//                         className="block text-[11px] font-semibold uppercase tracking-widest mt-1.5 mb-1.5"
//                         style={{ color: sellerPrimaryColor1+ sellerColorSuffixMedium }}>
//                         Select a Menu
//                     </label>
//                     <div className="relative">
//                         <select
//                             onChange={handleSampleMenuNameChange}
//                             className="w-full appearance-none rounded-xl border px-4 py-2.5 pr-10 text-sm font-medium
//                                 cursor-pointer outline-none transition-all duration-200
//                                 focus:ring-2 focus:ring-offset-1"
//                             style={{
//                                 color: colorDark,
//                                 backgroundColor: colorLight,
//                                 borderColor: colorDark,
//                             }}>
//                             {sampleMenus.map((c, i) => (
//                                 <option key={i} value={c._id}>{c.title}</option>
//                             ))}
//                         </select>
//                         {/* Custom chevron */}
//                         <div
//                             className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2"
//                             style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                             <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//                                 <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
//                             </svg>
//                         </div>
//                     </div>
//                 </div>

//                 {/* ── Two-column layout: side by side on md+, stacked on mobile
//                     flex flex-col md:flex-row gap-4
//                 ─────── */}
//                 <div className="grid grid-cols-2 sm:grid-cols-1 xs:grid-cols-1 gap-4">

//                     {/* ── Image Viewer Panel ──────────────────────────────────────────── */}
//                     <div
//                         className="rounded-xl border overflow-hidden relative flex-1"
//                         style={{ borderColor: colorDark }}>
//                         {/* Control bar */}
//                         <div
//                             className="flex items-center justify-between px-3 py-1.5 border-b"
//                             style={{ borderColor: colorLight, backgroundColor: colorLight }}>
//                             <span
//                                 className="text-[11px] font-semibold uppercase tracking-wider"
//                                 style={{ color: sellerPrimaryColor1 }}>
//                                 Preview
//                             </span>
//                             <div className="flex items-center gap-1">
//                                 <button
//                                     onClick={() => setSelectedImg(sampleMenuFileName)}
//                                     className="p-1.5 border-none rounded-lg transition-all duration-200 hover:scale-110"
//                                     style={{ 
//                                         color: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                         backgroundColor: colorLight, 
//                                         borderColor: sellerPrimaryColor1 + sellerColorSuffixDark
//                                     }}
//                                     title="Open full size in popup">
//                                     <MdOutlineOpenInBrowser size={18} />
//                                 </button>
//                                 <button
//                                     onClick={handleImageSizeChangeIncrease}
//                                     className="p-1.5 rounded-lg transition-all duration-200 hover:scale-110"
//                                     style={{ color: sellerPrimaryColor1, backgroundColor: colorLight }}
//                                     title="Zoom in">
//                                     <HiOutlineMagnifyingGlassPlus size={18} />
//                                 </button>
//                                 <button
//                                     onClick={handleImageSizeChangeDecrease}
//                                     className="p-1.5 rounded-lg transition-all duration-200 hover:scale-110"
//                                     style={{ color: sellerPrimaryColor1, backgroundColor: colorLight }}
//                                     title="Zoom out">
//                                     <HiOutlineMagnifyingGlassMinus size={18} />
//                                 </button>
//                             </div>
//                         </div>

//                         {/* Image area  */}
//                         <div
//                             className="overflow-auto items-center justify-center flex"
//                             style={{ height: '356px', padding: '8px', backgroundColor: colorLight }}>
//                             <div className="relative p-2 inline-block" style={{ width: `${imageSize + 4}px` }}>
//                                 <img
//                                     className="cursor-pointer transition-transform duration-200 hover:scale-[1.01]"
//                                     src={sampleMenuFileName}
//                                     onClick={() => setSelectedImg(sampleMenuFileName)}
//                                     style={{ width: `${imageSize}px`, height: 'auto' }}
//                                     alt="Sample menu preview"
//                                 />
//                                 <ImageModal
//                                     src={selectedImg}
//                                     onClose={() => setSelectedImg(null)}
//                                     title={sampleMenuTitle}
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     {/* ── Product List Panel ──────────────────────────────────────────── */}
//                     <div
//                         className="rounded-xl border overflow-hidden flex-1"
//                         style={{ borderColor: colorDark, backgroundColor: colorLight }}>
//                         {/* Add-to-cart CTA */}
//                         {hasProducts && (
//                             <div
//                                 className="px-3 pt-3 pb-2 border-b"
//                                 style={{ borderColor: colorLight, backgroundColor: colorLight }}>
//                                 <button
//                                     onClick={add_sample_menu_to_cart_local}
//                                     className="w-full flex items-center justify-center gap-1 py-2.5 px-4
//                                         rounded-xl text-sm font-semibold tracking-wide text-white
//                                         transition-all duration-200 hover:opacity-90 hover:shadow-md active:scale-[0.98]"
//                                     style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                     <MdOutlineRestaurantMenu size={20} />
//                                     {`Add All To My Menu (${products?.length})`}
//                                 </button>
//                                 <p
//                                     className="text-center text-[11px] mt-1.5 leading-tight"
//                                     style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                     Existing {sellerProductPluralTerm} will move to your Wishlist
//                                 </p>
//                                 {sellerPackageTitle && (
//                                     <p
//                                         className="text-center text-[12px] font-semibold mt-1"
//                                         style={{ color: sellerPrimaryColor1 }}>
//                                         {sellerPackageTitle}
//                                     </p>
//                                 )}
//                             </div>
//                         )}

//                     {/* Scrollable content */}
//                     <div
//                         className="overflow-auto"
//                         style={{ height: hasProducts ? '280px' : '320px', padding: '10px' }}>
//                         {/* Intro state */}
//                         {!hasProducts && (
//                             <div className="flex flex-col gap-4 py-4 px-1">
//                                 {[
//                                     { icon: '①', text: "Choose a sample menu from the selector above." },
//                                     { icon: '②', text: "You'll see both a Classic and Modern view side by side." },
//                                     { icon: '③', text: "Add the entire menu to your cart in one click." },
//                                 ].map(({ icon, text }, i) => (
//                                     <div key={i} className="flex items-start gap-3">
//                                         <span
//                                             className="text-lg font-bold shrink-0 leading-tight"
//                                             style={{ color: sellerPrimaryColor1 }}>
//                                             {icon}
//                                         </span>
//                                         <p className="text-sm leading-snug opacity-70" style={{ color: sellerPrimaryColor1 }}>
//                                             {text}
//                                         </p>
//                                     </div>
//                                 ))}
//                             </div>
//                         )}
//                         <div>
//                             {hasProducts && (
//                                 <ShopProductGridListView products={products}
//                                     styles="grid" showAllProductsButton={false} columnCount={1} />
//                             )}
//                         </div>
//                         {/* Product cards flex flex-col */}
//                         {hasProducts && (
//                             <div className="hidden  gap-3">
//                                 {products
//                                     .slice()
//                                     .sort((a, b) => a.name.localeCompare(b.name))
//                                     .map((p, i) => (
//                                         <div
//                                             key={i}
//                                             className="group relative rounded-xl border overflow-hidden
//                                                 transition-all duration-300
//                                                 hover:-translate-y-1 hover:shadow-xl"
//                                             style={{
//                                                 backgroundColor: colorLight,
//                                                 borderColor: colorDark,
//                                                 //boxShadow: '0 1px 4px ' + colorLight,
//                                             }}>
//                                             {/* ── Image with zoom + overlay ─────────────────── */}
//                                             <div className="relative overflow-hidden">
//                                                 <img
//                                                     className="w-full object-cover transition-transform duration-500 
//                                                     group-hover:scale-105"
//                                                     src={p.images[0]}
//                                                     alt={p.name}
//                                                     style={{ maxHeight: '140px' }}
//                                                 />

//                                                 {/* Color sweep overlay on hover */}
//                                                 <div
//                                                     className="absolute inset-0 opacity-0 group-hover:opacity-30 
//                                                     transition-opacity duration-300"
//                                                     style={{ backgroundColor: sellerPrimaryColor1 }}
//                                                 />

//                                                 {/* byThePan badge */}
//                                                 {p.byThePan !== 'NoPan' && (
//                                                     <div
//                                                         className="absolute top-2 left-2 text-[10px] text-white 
//                                                         font-semibold px-2 py-0.5 rounded-full"
//                                                         style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                                         {p.byThePan}
//                                                     </div>
//                                                 )}

//                                                 {/* Action buttons — slide up on hover */}
//                                                 <div
//                                                     className="absolute inset-x-0 bottom-0 flex justify-center items-center gap-2 pb-2
//                                                     translate-y-full group-hover:translate-y-0 transition-transform duration-300">
//                                                     <button
//                                                         onClick={() => openModal(p)}
//                                                         className="w-9 h-9 flex items-center justify-center rounded-full
//                                                         backdrop-blur-sm border text-sm
//                                                         transition-all duration-200 hover:scale-110 hover:shadow-lg"
//                                                         style={{ 
//                                                             backgroundColor: 'rgba(255,255,255,0.92)', 
//                                                             color: sellerPrimaryColor1, 
//                                                             borderColor: sellerPrimaryColor1
//                                                         }}
//                                                         title="Quick View">
                                                        
//                                                         <div className="icon-container">
//                                                             <span className='icon flex justify-center items-center'>
//                                                                 &nbsp;<FaEye size={18} />&nbsp;
//                                                             </span>
//                                                             <div className="tooltip" style={tooltipHoverStyle}>Quick<br />View</div>
//                                                         </div>
//                                                     </button>

//                                                     {sellerBoolShowSiteChat && (
//                                                         <button
//                                                             onClick={() => redirect_chat_page(p.name)}
//                                                             className="w-9 h-9 flex items-center justify-center rounded-full
//                                                             backdrop-blur-sm border text-sm
//                                                             transition-all duration-200 hover:scale-110 hover:shadow-lg"
//                                                             style={{ 
//                                                                 backgroundColor: 'rgba(255,255,255,0.92)', 
//                                                                 color: sellerPrimaryColor1, 
//                                                                 borderColor: sellerPrimaryColor1 
//                                                             }}
//                                                             title="Chat With Us">
//                                                             <div className="icon-container">
//                                                                 <span className='icon flex justify-center items-center'>
//                                                                     &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
//                                                                 </span>
//                                                                 <div className="tooltip" style={tooltipHoverStyle}>Chat<br />With Us</div>
//                                                             </div>
//                                                         </button>
//                                                     )}
//                                                 </div>
//                                             </div>

//                                             {/* ── Card body ─────────────────────────────────── */}
//                                             <div className="px-3 pt-2 pb-1">
//                                                 {/* Animated left-border accent on hover */}
//                                                 <div
//                                                     className="absolute left-0 top-0 bottom-0 w-[3px] rounded-l-xl
//                                                     scale-y-0 group-hover:scale-y-100 transition-transform 
//                                                     duration-300 origin-top"
//                                                     style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}
//                                                 />
//                                                 <div
//                                                     className="font-semibold text-sm leading-snug tracking-tight truncate"
//                                                     style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                                     {p.name}
//                                                 </div>

//                                                 <div className="flex items-center gap-2 mt-0.5 mb-1">
//                                                     {sellerBoolShowSitePayments && (
//                                                         <span
//                                                             className="text-sm font-bold"
//                                                             style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                                             {currencyFormat.format(p.price)}
//                                                         </span>
//                                                     )}
//                                                     {sellerBoolShowSiteRating && (
//                                                         <React.Suspense fallback={null}>
//                                                             <Rating ratings={p.rating} />
//                                                         </React.Suspense>
//                                                     )}
//                                                 </div>
//                                             </div>

//                                             {/* ── Description strip ─────────────────────────── */}
//                                             <div
//                                                 className="px-3 py-1.5 text-[11px] leading-snug border-t opacity-70 truncate"
//                                                 style={{
//                                                     borderColor: colorLight,
//                                                     color: sellerPrimaryColor1,
//                                                     backgroundColor: colorLight,
//                                                 }}>
//                                                 {p.description?.substring(0, parseInt(screenWidth / 28))}…
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>
//                     </div>

//                 </div>{/* end two-column */}
//             </div>

//             <Modal2 isOpen={!!modalProduct} onClose={closeModal} product={modalProduct} />
//         </div>
//     </div>
//   );
// };

// export default SampleMenusImages;








//refactored
// import React, { useEffect, useState, lazy }  from 'react';
// import {  useNavigate, Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { sampleMenu_webSiteOrigin_get } from '../../store/reducers/sampleMenuReducer';
// import { products_get_by_productIds } from '../../store/reducers/homeReducer';
// import { add_to_cart, get_cart_products, move_from_cart_to_wishlist, messageClear, successMessage, errorMessage } 
//     from '../../store/reducers/cartReducer';

// import { HiOutlineMagnifyingGlassPlus } from "react-icons/hi2";
// import { HiOutlineMagnifyingGlassMinus  } from "react-icons/hi2";
// import { MdOutlineRestaurantMenu, MdOutlineOpenInBrowser } from "react-icons/md";
// import { FaEye, FaRegTrashAlt} from "react-icons/fa";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";

// import Modal2 from '../Modal2';
// import useWindowSize from '../../utils/useWindowSize';
// import GetSellerConfig from '../GetSellerConfig';

// import toast from 'react-hot-toast';
// import { currencyFormat } from '../CurrencyFormat';
// import ImageModal from './ImageModal';

// import Moment from 'moment/moment';
// import config from '../../config';

// const Rating = lazy(()=> import('../Rating')) 

// const SampleMenusImages = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL
//     const { userInfo } = useSelector(state => state.auth)
        
//     let {allSiteProducts, products, totalProduct } = useSelector(state => state.home)
//     const {sampleMenus, sampleMenu, totalSampleMenu} = useSelector(state=> state.sampleMenu)
//     const { cart_products, cart_product_count, buy_product_item, wishlist_count,
//         shipping_fee, outofstock_products, errorMessage, successMessage } = useSelector(state => state.cart)
//     //const { seller } = useSelector(state => state.seller)
    
//     const { 
//         sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//         sellerProductPluralTerm,
//         sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowSocialMedia,
//         sellerBoolShowSiteSamplesMenus, sellerBoolShowSitePackages, sellerBoolShowCustomerTestimonials, sellerBoolShowSitePayments,
//         sellerBoolShowSiteRating
//     } = GetSellerConfig();

//     const sampleMenusIntro1 = "Choose A Sample Menu To View You Will See Two Versions Of The Menu "
//     const sampleMenusIntro2 = "A Classic View On The Left And A Modern View On The Right. "
//     const sampleMenusIntro3 = "You Can Add The Entire Menu To Your Cart At Once."
    
//     const [selectedImg, setSelectedImg] = useState(null);

//     const tooltipHoverStyle = {
//         color: 'white',
//         backgroundColor: sellerPrimaryColor1
//     };
//     const { screenWidth, screenHeight } = useWindowSize();
    
//     const [modalProduct, setModalProduct] = useState(null);
//     const openModal = (product) => {
//         setModalProduct(product);
//     };
//     const closeModal = () => {
//         setModalProduct(null);
//     };

//     const redirect_chat_page = (chatTopic) => {
//         if (userInfo) {
//             navigate(`/customerDashboard/chat/${chatTopic}`)
//         } else {
//             navigate('/login')
//         }
//     }
    
//     const dispatch = useDispatch()
//     const navigate = useNavigate()

//     useEffect(() => {
//         dispatch(sampleMenu_webSiteOrigin_get(sellerFrontendURL))
//     },[sellerFrontendURL, dispatch])

//     useEffect(() => {
//         dispatch(get_cart_products(userInfo.id))
//     },[])
        
//     const add_sample_menu_to_cart_local = () => {
//         if (userInfo) {
//             if (cart_products.length > 0) {
//                 cart_products[0].products.map((p, i) => {
//                     dispatch(move_from_cart_to_wishlist(p._id))
//                 })
//             }

//             products.map((p, i) => {
//                 dispatch(add_to_cart({
//                     userId: userInfo.id,
//                     quantity: 1,
//                     productId : p._id,
//                     portionSize: ''
//                 }))  
//             })
//         } else {
//             navigate('/login')
//         }
//     }

//     const myScreenWidth = 270;
//     const [imageSize, setImageSize] = useState(myScreenWidth);
//     const minImageSize = 50;
//     const imageSizeStep = 30;

//     const handleImageSizeChangeIncrease = () => {
//         setImageSize(prevImageSize => prevImageSize + imageSizeStep);
//     };

//     const handleImageSizeChangeDecrease = () => {
//         if (imageSize > minImageSize) {
//             setImageSize(prevImageSize => prevImageSize - imageSizeStep);
//         }
//     };

//     const [sampleMenuFileName, setSampleMenuFileName] = useState('');
//     const [sampleMenuTitle, setSampleMenuTitle] = useState('');
//     const [productsDisplay, setProductsDisplay] = useState('[]');
//     const [sellerPackageTitle, setSellerPackageTitle] = useState('');

//     useEffect(() => {
//         if (sampleMenus[0]?.sampleMenuFile) {
//             setSampleMenuFileName(sampleMenus[0]?.sampleMenuFile)
//             setSampleMenuTitle(sampleMenus[0]?.title)
//         }
//     },[sampleMenus])

//     const handleSampleMenuNameChange = (event) => {
//         const sampleMenuId = event.target.value
                                
//         try {
//             sampleMenus.forEach((sampleMenu) => {
//                 if (sampleMenu._id === sampleMenuId) {
//                     setSampleMenuFileName(sampleMenu.sampleMenuFile)
//                     setSampleMenuTitle(sampleMenu.title)
//                     setProductsDisplay(sampleMenu.selectedProducts)
//                     setSellerPackageTitle(
//                         sampleMenu?.packageDetails && sampleMenu?.packageDetails.length > 0 ?
//                         ' Associated Package: ' + sampleMenu?.packageDetails[0]?.title : ''
//                     )
                    
//                     let productIds = ''
//                     if (JSON.parse(sampleMenu.selectedProducts).length > 0) {
//                         JSON.parse(sampleMenu.selectedProducts).map((p, i) => (
//                             productIds += `${p._id},`
//                         ))
//                         productIds = productIds.substring(0, productIds.length - 1);
//                         dispatch(products_get_by_productIds(productIds))
//                     }
//                 }
//             })
//         } catch (error) {
            
//         }
//     }

//     useEffect(() => { 
//         if (successMessage) {
//             toast.success(successMessage)
//             dispatch(messageClear())  
//             dispatch(get_cart_products(userInfo.id))
//         } 
//         if (errorMessage) {
//             toast.error(errorMessage)
//             dispatch(messageClear())  
//         } 
//     },[successMessage, errorMessage])

//     return (
//         <div className='p-4 rounded-md border'
//             style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//             <div className='text-2xl font-bold flex gap-1 mb-2 '>
//                 <MdOutlineRestaurantMenu className='mt-1 mr-1' /> Sample Menus
//             </div>
//             <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] border-none border-red-600 '>
//                 <div className='mb-1 mt-1 mx-auto flex flex-col justify-center items-center place-content-center'
//                     style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                     <div>
//                         <select onChange={(e) => handleSampleMenuNameChange(e)}
//                             className='m-1 border rounded-lg px-2 py-1 font-semibold text-md cursor-pointer' 
//                             style={{width: myScreenWidth - 20 + 'px', color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1, borderColor:sellerPrimaryColor1}}>
//                             {
//                                 sampleMenus.map((c, i) => 
//                                     <option key={i} value={c._id} className={`text-sm block`}>
//                                         {c.title}
//                                     </option>
//                                 )
//                             }
//                         </select>
//                     </div>
                    
//                     <div className="items-center justify-center justify-items-center">
//                         <table className="border-collapse border-none border-gray-700">
//                             <thead>
//                                 <tr className='hidden' >
//                                     <th className="border border-gray-300 p-2">Header 1</th>
//                                     <th className="border border-gray-300 p-2">Header 2</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr className="table-row lg:flex lg:flex-col">
//                                     <td className="align-top  border-none border-gray-700 table-cell lg:block" >
//                                         <div className={` border p-2 m-1 overflow-auto h-[356px]`} 
//                                             style={{ overflow: 'auto', padding: '4px',  
//                                                 width: myScreenWidth + 30 + 'px', borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1 }}>
//                                             <div className="relative" style={{ width: `${imageSize + 4}px`, height: 'auto' }}>
//                                                 <img className='cursor-pointer' src={sampleMenuFileName} 
//                                                     onClick={() => setSelectedImg(sampleMenuFileName)}
//                                                     style={{ width: `${imageSize}px`, height: 'auto' }} alt="Resizable" />

//                                                 <ImageModal 
//                                                     src={selectedImg} 
//                                                     onClose={() => setSelectedImg(null)} title={sampleMenuTitle} />

//                                                 <div title="Resize Image" 
//                                                     className="absolute top-1 left-1 p-0.5 bg-white bg-opacity-75 rounded-full 
//                                                     cursor-pointer hover:bg-opacity-100 transition duration-300">
//                                                     <MdOutlineOpenInBrowser className='mb-0.5' size={22} onClick={() => setSelectedImg(sampleMenuFileName)} style={{color:sellerPrimaryColor1}} />
//                                                     <HiOutlineMagnifyingGlassPlus className='mb-0.5' onClick={handleImageSizeChangeIncrease} style={{color:sellerPrimaryColor1}} size={24} />
//                                                     <HiOutlineMagnifyingGlassMinus onClick={handleImageSizeChangeDecrease} style={{color:sellerPrimaryColor1}} size={24} />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </td>
                                    
//                                     <td className="align-top border-none border-gray-700 table-cell lg:block">
//                                         <div className={` text-sm border p-1 m-1 `} 
//                                             style={{width: myScreenWidth  + 30 + 'px', borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                             <div className={`  ${productsDisplay === '[]' ? 'hidden' : ''} 
//                                                 border-none border-black items-center justify-content-center justify-center text-center text-[12px]`}>
//                                                 <div className={` ${productsDisplay === '[]' ? 'hidden' : 'block'} `}>
//                                                     <div className={`items-center justify-content-center flex flex-col justify-center text-center`}>
//                                                         <button onClick={add_sample_menu_to_cart_local}
//                                                             className='py-1 px-3 flex text-white rounded-md text-[16px] text-center items-center 
//                                                             justify-center' 
//                                                             style={{width: myScreenWidth - 40 + 'px', backgroundColor:sellerPrimaryColor1, color:sellerSecondaryColor1, borderColor:sellerSecondaryColor1}}>
//                                                             <MdOutlineRestaurantMenu className='mr-1 text-[18px]' /> Add All To My Menu
//                                                         </button>
//                                                     </div>
//                                                     <div className={` ${productsDisplay === '[]' ? 'hidden' : ''} 
//                                                         border-none border-black items-center justify-content-center 
//                                                         justify-center text-center text-[12px] text-pretty`}>
//                                                         Existing {sellerProductPluralTerm} In My Menu Will Get Moved To My Wishlist
//                                                     </div>
//                                                     <div className={`  ${productsDisplay === '[]' ? 'hidden' : ''} 
//                                                         border-none border-black items-center justify-content-center 
//                                                         justify-center text-center text-[13px] font-semibold mb-1 `}>
//                                                         {sellerPackageTitle}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className={`overflow-auto h-[260px]`} 
//                                                 style={{ overflow: 'auto', padding: '6px'}}>
//                                                 <div className={` ${productsDisplay === '[]' ? 'block' : 'hidden'} 
//                                                     text-md font-bold flex flex-col gap-3 `} >
//                                                     <div>{ sampleMenusIntro1 }</div>
//                                                     <div>{ sampleMenusIntro2 }</div>
//                                                     <div>{ sampleMenusIntro3 }</div>
//                                                 </div>
                                
//                                                 <div className={` ${productsDisplay === '[]' ? 'hidden' : 'block'}  `} >
//                                                 {
//                                                     products.slice(0, products.length).sort((a, b) => a.name.localeCompare(b.name)).map((p, i) => (
//                                                         <div key={i} className='border-2 mb-4 group transition-all duration-500 hover:shadow-md hover:-mt-3'
//                                                             style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                             <div className='relative overflow-hidden'>
//                                                                 <div className="relative text-center">
//                                                                     <img className={`sm:w-full w-full`} src={p.images[0]}  alt="" />  
//                                                                     <div className={` ${p.byThePan === 'NoPan' ? 'hidden' : ''}  
//                                                                         m-1 border w-[97%] h-[30px] absolute top-0 left-0 text-center`}
//                                                                         style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                                         {p.byThePan}
//                                                                     </div>
//                                                                 </div>
//                                                                 <ul className='flex transition-all duration-700 -bottom-10 justify-center items-center 
//                                                                     gap-2 absolute w-full group-hover:bottom-3'>
//                                                                     <Link onClick={() => openModal(p)}
//                                                                         className='w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all'
//                                                                         style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                                         <div className="icon-container">
//                                                                             <span className='icon flex justify-center items-center'>
//                                                                                 &nbsp;<FaEye />&nbsp;
//                                                                             </span>
//                                                                             <div className="tooltip" style={tooltipHoverStyle}>Quick<br />View</div>
//                                                                         </div>
//                                                                     </Link>
//                                                                     <span onClick={() => redirect_chat_page(p.name)} 
//                                                                         className={` ${sellerBoolShowSiteChat ? '' : 'hidden'}  
//                                                                         w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all`}
//                                                                         style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                                         <div className="icon-container">
//                                                                             <span className='icon flex justify-center items-center'>
//                                                                                 &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
//                                                                             </span>
//                                                                             <div className="tooltip" style={tooltipHoverStyle}>Chat<br />With Us</div>
//                                                                         </div>
//                                                                     </span>
//                                                                 </ul>
//                                                             </div>
//                                                             <div className='py-3 px-2'>
//                                                                 <div className='sm:inline-block md-lg:hidden md:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden'>
//                                                                     <span className='font-bold'>{p.name}</span>
//                                                                 </div>
//                                                                 <div className='sm:hidden'>
//                                                                     <span className='font-bold'>{p.name?.substring(0, parseInt(screenWidth / 66))}</span>
//                                                                     <span className={` ${(p.name?.substring(0, parseInt(screenWidth / 66))?.length >= p.name?.length) ? 'hidden' : '' } `}> ...</span>
//                                                                 </div>
//                                                                 <div className='flex justify-start items-center gap-3'>
//                                                                     <span className={`${sellerBoolShowSitePayments ? '' : 'hidden'} text-md font-semibold`}>
//                                                                         {currencyFormat.format(p.price)}
//                                                                     </span>
//                                                                     <div className={`${sellerBoolShowSiteRating ? 'flex' : 'hidden'} `}>
//                                                                         <Rating ratings={p.rating} />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                             <div className={`${p.portionSizes === '' ? '' : ''} 
//                                                                 border px-1 py-1 mb-1 w-full text-[14px] font-semibold`}
//                                                                 style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                                                 <span className='sm:inline-block md-lg:hidden md:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden'>
//                                                                     {p.description?.substring(0, parseInt(screenWidth / 10))} ...
//                                                                 </span>
//                                                                 <span className='sm:hidden'>
//                                                                     {p.description?.substring(0, parseInt(screenWidth / 50))} ...
//                                                                 </span>
//                                                             </div>
//                                                         </div>
//                                                     ))
//                                                 }
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>
//                     <Modal2 isOpen={!!modalProduct} onClose={closeModal} product={modalProduct} />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default SampleMenusImages;








// my original code
// import React, { useEffect, useState, lazy }  from 'react';
// import {  useNavigate, Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { sampleMenu_webSiteOrigin_get } from '../../store/reducers/sampleMenuReducer';
// import { products_get_by_productIds } from '../../store/reducers/homeReducer';
// import { add_to_cart, get_cart_products, move_from_cart_to_wishlist, messageClear, successMessage, errorMessage } 
//     from '../../store/reducers/cartReducer';

// import { HiOutlineMagnifyingGlassPlus } from "react-icons/hi2";
// import { HiOutlineMagnifyingGlassMinus  } from "react-icons/hi2";
// import { MdOutlineRestaurantMenu, MdOutlineOpenInBrowser } from "react-icons/md";
// import { FaEye, FaRegTrashAlt} from "react-icons/fa";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";

// import Modal2 from '../Modal2';
// import useWindowSize from '../../utils/useWindowSize';
// import toast from 'react-hot-toast';
// import { currencyFormat } from '../CurrencyFormat';
// import ImageModal from './ImageModal';

// import Moment from 'moment/moment';
// import config from '../../config';

// const Rating = lazy(()=> import('../Rating')) 
// //npm install yet-another-react-lightbox
// //https://www.npmjs.com/package/lightbox.js-react
// // react single image popup
// // https://www.npmjs.com/package/react-modal-image
// // gemini react create component to show image in modal

// const SampleMenusImages = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL
//     const { seller } = useSelector(state => state.seller)
//     const { userInfo } = useSelector(state => state.auth)
        
//     let {allSiteProducts, products, totalProduct } = useSelector(state => state.home)
//     const {sampleMenus, sampleMenu, totalSampleMenu} = useSelector(state=> state.sampleMenu)
//     const { cart_products, cart_product_count, buy_product_item, wishlist_count,
//         shipping_fee, outofstock_products, errorMessage, successMessage } = useSelector(state => state.cart) //outOfStockProduct price,
    
//     //console.log('sampleMenu\n ', sampleMenu[0]?.sampleMenuFile) //sampleMenu[0]?.sampleMenuFile)//[0]?.sampleMenuFile
    
//     const sellerId = seller._id 
//     const sellerPrimaryColor1 = seller.frontEndPrimaryColor1
//     const sellerSecondaryColor1 = seller.frontEndSecondaryColor1

//     const sellerShopName = seller?.shopName
//     const sellerProductPluralTerm = seller.productPluralTerm
//     const sellerShoppingTerm = seller.shoppingTerm

//     const sellerBoolShowSitePayments = seller.isVisibleSitePayments === 'Show' ? true : false
//     const sellerBoolShowSiteRating = seller.isVisibleSiteRating === 'Show' ? true : false
//     const sellerBoolShowSiteChat = seller.isVisibleSiteChat === 'Show' ? true : false
    
//     const sampleMenusIntro1 = "Choose A Sample Menu To View You Will See Two Versions Of The Menu "
//     const sampleMenusIntro2 = "A Classic View On The Left And A Modern View On The Right. "
//     const sampleMenusIntro3 = "You Can Add The Entire Menu To Your Cart At Once."
    
//     const [selectedImg, setSelectedImg] = useState(null);

//     const tooltipHoverStyle = {
//         color: 'white',
//         backgroundColor: sellerPrimaryColor1
//     };
//     const { screenWidth, screenHeight } = useWindowSize();
    
//     const [modalProduct, setModalProduct] = useState(null);
//     const openModal = (product) => {
//         setModalProduct(product);
//     };
//     const closeModal = () => {
//         setModalProduct(null);
//     };

//     const redirect_chat_page = (chatTopic) => {
//         if (userInfo) {
//             navigate(`/customerDashboard/chat/${chatTopic}`)
//         } else {
//             navigate('/login')
//         }
//     }
    
//     const dispatch = useDispatch()
//     const navigate = useNavigate()
        
//     //let arrSampleMenuFile = []

//     useEffect(() => {
//         dispatch(sampleMenu_webSiteOrigin_get(sellerFrontendURL))
//         //console.log('useEffect sampleMenu\n', sampleMenu[0]?.sampleMenuFile)//[0]?.sampleMenuFile
//     },[sellerFrontendURL, dispatch])//, sampleMenu

//     useEffect(() => {
//         dispatch(get_cart_products(userInfo.id))
//     },[])
        
//     const add_sample_menu_to_cart_local = () => {
//         if (userInfo) {
//             //loop
//             if (cart_products.length > 0) {
//                 cart_products[0].products.map((p, i) => {
//                     //console.log('p._id ', p._id)
//                     dispatch(move_from_cart_to_wishlist(p._id))
//                 })
//             }

//             products.map((p, i) => {
//                 //console.log('p._id ', p._id, p.name)
//                 dispatch(add_to_cart({
//                     userId: userInfo.id,
//                     quantity: 1,
//                     productId : p._id, // product._id,
//                     portionSize: '' //portionSize
//                 }))  
//             })
//         } else {
//             navigate('/login')
//         }
//     }

//     //https://gemini.google.com/app/07e6e57ad8ceaa8c
//     //create react component to resize image with plus sign and minus sign buttons
//     const myScreenWidth = 270; //240
//     const [imageSize, setImageSize] = useState(myScreenWidth);//initialSize
//     const minImageSize = 50;
//     const imageSizeStep = 30;

//     const handleImageSizeChangeIncrease = () => {
//         setImageSize(prevImageSize => prevImageSize + imageSizeStep);
//     };

//     const handleImageSizeChangeDecrease = () => {
//         if (imageSize > minImageSize) {
//             setImageSize(prevImageSize => prevImageSize - imageSizeStep);
//         }
//     };

//     //let classSampleMenuFile = sampleMenu[0]?.sampleMenuFile
//     // console.log('sampleMenus\n', sampleMenus[0]?.sampleMenuFile)//[0]?.sampleMenuFile
//     const [sampleMenuFileName, setSampleMenuFileName] = useState(''); //classSampleMenuFile
//     const [sampleMenuTitle, setSampleMenuTitle] = useState('');
//     const [productsDisplay, setProductsDisplay] = useState('[]');
//     const [sellerPackageTitle, setSellerPackageTitle] = useState('');

//     //selectedProducts
//     useEffect(() => {
//         if (sampleMenus[0]?.sampleMenuFile) {
//             setSampleMenuFileName(sampleMenus[0]?.sampleMenuFile)
//             setSampleMenuTitle(sampleMenus[0]?.title)
//         }
//     },[sampleMenus])

//     useEffect(() => {
//         if (sampleMenus[0]?.sampleMenuFile) {
//             setSampleMenuFileName(sampleMenus[0]?.sampleMenuFile)
//             setSampleMenuTitle(sampleMenus[0]?.title)
//         }
//     },[sampleMenus])

//     const handleSampleMenuNameChange = (event) => {
//         //console.log('event.target.value ', event.target.value)
//         const sampleMenuId = event.target.value

//         // d?.packageDetails && d?.packageDetails.length > 0 ?
//         // d?.packageDetails[0]?.title : 'No Package'
                                
//         try {
//             //console.log('sampleMenuId ', sampleMenuId)

//             sampleMenus.forEach((sampleMenu) => {
//                 if (sampleMenu._id === sampleMenuId) {
//                     setSampleMenuFileName(sampleMenu.sampleMenuFile)
//                     setSampleMenuTitle(sampleMenu.title)
//                     setProductsDisplay(sampleMenu.selectedProducts)
//                     setSellerPackageTitle(
//                         sampleMenu?.packageDetails && sampleMenu?.packageDetails.length > 0 ?
//                         ' Associated Package: ' + sampleMenu?.packageDetails[0]?.title : ''
//                     )
                    
//                     //console.log('sampleMenu.selectedProducts ', sampleMenu?.packageDetails[0]?.title)
                    
//                     let productIds = ''
//                     //products = null setProductsDisplay
//                     if (JSON.parse(sampleMenu.selectedProducts).length > 0) {
//                         //setCustomMenuItems(JSON.parse(eventDetails?.customMenuProducts) )//|| eventDetails?.customMenuProducts
//                         //console.log('eventDetails?.customMenuProducts', eventDetails?.customMenuProducts)
//                         JSON.parse(sampleMenu.selectedProducts).map((p, i) => (
//                             productIds += `${p._id},`
//                         ))
//                         productIds = productIds.substring(0, productIds.length - 1);
//                         //console.log('productIds', productIds)
//                         dispatch(products_get_by_productIds(productIds))
//                         // setProductsDisplay(true)
//                         //console.log('allSiteProducts ', allSiteProducts)
//                         //console.log('products ', products)
//                     } else {
//                         // setProductsDisplay(false)
//                     }
//                     //console.log('productsDisplay ', productsDisplay)
//                 }
//             })
//         } catch (error) {
            
//         }
//     }

//     useEffect(() => { 
//         if (successMessage) {
//             toast.success(successMessage)
//             dispatch(messageClear())  
//             dispatch(get_cart_products(userInfo.id))
//         } 
//         if (errorMessage) {
//             toast.error(errorMessage)
//             dispatch(messageClear())  
//         } 
//     },[successMessage, errorMessage])

//     return (
//         <div className='p-4 rounded-md border'
//             style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//             <div className='text-2xl font-bold flex gap-1 mb-2 '>
//                 <MdOutlineRestaurantMenu className='mt-1 mr-1' /> Sample Menus
//             </div>
//             { /*mx-auto flex flex-wrap justify-center items-center place-content-center*/ }
//             <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] border-none border-red-600 '>
//                 <div className='mb-1 mt-1 mx-auto flex flex-col justify-center items-center place-content-center'
//                     style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                     <div>
//                         {
//                             //console.log('sampleMenus in return ', sampleMenus)
//                         }
//                         <select onChange={(e) => handleSampleMenuNameChange(e)}
//                             className='m-1 border rounded-lg px-2 py-1 font-semibold text-md cursor-pointer' 
//                             style={{width: myScreenWidth - 20 + 'px', color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1, borderColor:sellerPrimaryColor1}}>
//                             {
//                                 sampleMenus.map((c, i) => 
//                                     <option key={i} value={c._id} className={`text-sm block`}>
//                                         {c.title}
//                                     </option>
//                                 )
//                             }
//                         </select>
//                     </div>
                    
//                     <div className="items-center justify-center justify-items-center">
//                         {/* min-w-full  */}
//                         <table className="border-collapse border-none border-gray-700">
//                             <thead>
//                                 <tr className='hidden' >
//                                     <th className="border border-gray-300 p-2">Header 1</th>
//                                     <th className="border border-gray-300 p-2">Header 2</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {/* Key here: Default is table-row, but we override at 'lg' breakpoint */}
//                                 <tr className="table-row lg:flex lg:flex-col">
//                                     {/* On small screens, these TDs are normal table cells (side-by-side) */}
//                                     {/* On large screens (lg:), they become blocks and stack maxWidth: '400px', maxHeight: '50vh',*/}
//                                     {/* sampleMenuTitle */}
//                                     <td className="align-top  border-none border-gray-700 table-cell lg:block" >
//                                         <div className={` border p-2 m-1 overflow-auto h-[356px]`} 
//                                             style={{ overflow: 'auto', padding: '4px',  
//                                                 width: myScreenWidth + 30 + 'px', borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1 }}>
//                                             <div className="relative" style={{ width: `${imageSize + 4}px`, height: 'auto' }}>
//                                                 <img className='cursor-pointer' src={sampleMenuFileName} 
//                                                     onClick={() => setSelectedImg(sampleMenuFileName)}
//                                                     style={{ width: `${imageSize}px`, height: 'auto' }} alt="Resizable" />

//                                                 <ImageModal 
//                                                     src={selectedImg} 
//                                                     onClose={() => setSelectedImg(null)} title={sampleMenuTitle} />

//                                                 <div title="Resize Image" 
//                                                     className="absolute top-1 left-1 p-0.5 bg-white bg-opacity-75 rounded-full 
//                                                     cursor-pointer hover:bg-opacity-100 transition duration-300">
//                                                     <MdOutlineOpenInBrowser className='mb-0.5' size={22} onClick={() => setSelectedImg(sampleMenuFileName)} style={{color:sellerPrimaryColor1}} />
//                                                     <HiOutlineMagnifyingGlassPlus className='mb-0.5' onClick={handleImageSizeChangeIncrease} style={{color:sellerPrimaryColor1}} size={24} />
//                                                     <HiOutlineMagnifyingGlassMinus onClick={handleImageSizeChangeDecrease} style={{color:sellerPrimaryColor1}} size={24} />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </td>
                                    
//                                     <td className="align-top border-none border-gray-700 table-cell lg:block">
//                                         <div className={` text-sm border p-1 m-1 `} 
//                                             style={{width: myScreenWidth  + 30 + 'px', borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                             <div className={`  ${productsDisplay === '[]' ? 'hidden' : ''} 
//                                                 border-none border-black items-center justify-content-center justify-center text-center text-[12px]`}>
//                                                 <div className={` ${productsDisplay === '[]' ? 'hidden' : 'block'} `}>
//                                                     <div className={`items-center justify-content-center flex flex-col justify-center text-center`}>
//                                                         <button onClick={add_sample_menu_to_cart_local}
//                                                             className='py-1 px-3 flex text-white rounded-md text-[16px] text-center items-center 
//                                                             justify-center' 
//                                                             style={{width: myScreenWidth - 40 + 'px', backgroundColor:sellerPrimaryColor1, color:sellerSecondaryColor1, borderColor:sellerSecondaryColor1}}>
//                                                             <MdOutlineRestaurantMenu className='mr-1 text-[18px]' /> Add All To My Menu
//                                                         </button>
//                                                     </div>
//                                                     <div className={` ${productsDisplay === '[]' ? 'hidden' : ''} 
//                                                         border-none border-black items-center justify-content-center 
//                                                         justify-center text-center text-[12px] text-pretty`}>
//                                                         Existing {sellerProductPluralTerm} In My Menu Will Get Moved To My Wishlist
//                                                     </div>
//                                                     <div className={`  ${productsDisplay === '[]' ? 'hidden' : ''} 
//                                                         border-none border-black items-center justify-content-center 
//                                                         justify-center text-center text-[13px] font-semibold mb-1 `}>
//                                                         {sellerPackageTitle}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             {/*  , maxWidth: '400px', maxHeight: '50vh' */}
//                                             <div className={`overflow-auto h-[260px]`} 
//                                                 style={{ overflow: 'auto', padding: '6px'}}>
//                                                 <div className={` ${productsDisplay === '[]' ? 'block' : 'hidden'} 
//                                                     text-md font-bold flex flex-col gap-3 `} >
//                                                     <div>{ sampleMenusIntro1 }</div>
//                                                     <div>{ sampleMenusIntro2 }</div>
//                                                     <div>{ sampleMenusIntro3 }</div>
//                                                 </div>
                                
//                                                 <div className={` ${productsDisplay === '[]' ? 'hidden' : 'block'}  `} >
//                                                 {
//                                                     products.slice(0, products.length).sort((a, b) => a.name.localeCompare(b.name)).map((p, i) => (
//                                                         <div key={i} className='border-2 mb-4 group transition-all duration-500 hover:shadow-md hover:-mt-3'
//                                                             style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                             <div className='relative overflow-hidden'>
//                                                                 <div className="relative text-center">
//                                                                     <img className={`sm:w-full w-full`} src={p.images[0]}  alt="" />  
//                                                                     <div className={` ${p.byThePan === 'NoPan' ? 'hidden' : ''}  
//                                                                         m-1 border w-[97%] h-[30px] absolute top-0 left-0 text-center`}
//                                                                         style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                                         {p.byThePan}
//                                                                     </div>
//                                                                 </div>
//                                                                 <ul className='flex transition-all duration-700 -bottom-10 justify-center items-center 
//                                                                     gap-2 absolute w-full group-hover:bottom-3'>
//                                                                     <Link onClick={() => openModal(p)}
//                                                                         className='w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all'
//                                                                         style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                                         <div className="icon-container">
//                                                                             <span className='icon flex justify-center items-center'>
//                                                                                 &nbsp;<FaEye />&nbsp;
//                                                                             </span>
//                                                                             <div className="tooltip" style={tooltipHoverStyle}>Quick<br />View</div>
//                                                                         </div>
//                                                                     </Link>
//                                                                     <span onClick={() => redirect_chat_page(p.name)} 
//                                                                         className={` ${sellerBoolShowSiteChat ? '' : 'hidden'}  
//                                                                         w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all`}
//                                                                         style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                                         <div className="icon-container">
//                                                                             <span className='icon flex justify-center items-center'>
//                                                                                 &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
//                                                                             </span>
//                                                                             <div className="tooltip" style={tooltipHoverStyle}>Chat<br />With Us</div>
//                                                                         </div>
//                                                                     </span>
//                                                                 </ul>
//                                                             </div>
//                                                             <div className='py-3 px-2'>
//                                                                 <div className='sm:inline-block md-lg:hidden md:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden'>
//                                                                     <span className='font-bold'>{p.name}</span>
//                                                                 </div>
//                                                                 <div className='sm:hidden'>
//                                                                     <span className='font-bold'>{p.name?.substring(0, parseInt(screenWidth / 66))}</span>
//                                                                     <span className={` ${(p.name?.substring(0, parseInt(screenWidth / 66))?.length >= p.name?.length) ? 'hidden' : '' } `}> ...</span>
//                                                                 </div>
//                                                                 <div className='flex justify-start items-center gap-3'>
//                                                                     <span className={`${sellerBoolShowSitePayments ? '' : 'hidden'} text-md font-semibold`}>
//                                                                         {currencyFormat.format(p.price)}
//                                                                     </span>
//                                                                     <div className={`${sellerBoolShowSiteRating ? 'flex' : 'hidden'} `}>
//                                                                         <Rating ratings={p.rating} />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                             <div className={`${p.portionSizes === '' ? '' : ''} 
//                                                                 border px-1 py-1 mb-1 w-full text-[14px] font-semibold`}
//                                                                 style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                                                 <span className='sm:inline-block md-lg:hidden md:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden'>
//                                                                     {p.description?.substring(0, parseInt(screenWidth / 10))} ...
//                                                                 </span>
//                                                                 <span className='sm:hidden'>
//                                                                     {p.description?.substring(0, parseInt(screenWidth / 50))} ...
//                                                                 </span>
//                                                             </div>
//                                                         </div>
//                                                     ))
//                                                 }
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>
//                     <Modal2 isOpen={!!modalProduct} onClose={closeModal} product={modalProduct} />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default SampleMenusImages;
